/* ============================================================
   section-custom-footer.js  —  v2
   assets/section-custom-footer.js

   Newsletter AJAX submit — no page reload
   ============================================================ */

(function () {
  'use strict';

  function initNewsletterForm() {
    var form = document.getElementById('footer-newsletter-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput  = form.querySelector('.footer-email-input');
      var submitBtn   = form.querySelector('.footer-signup-btn');
      var successMsg  = form.querySelector('.footer-success-msg');
      var errorMsg    = form.querySelector('.footer-error-msg');
      var originalTxt = submitBtn ? submitBtn.textContent : 'Sign Up';

      if (!emailInput || !emailInput.value.trim()) return;

      /* Loading state */
      if (submitBtn) {
        submitBtn.disabled    = true;
        submitBtn.textContent = '...';
        submitBtn.style.opacity = '0.6';
      }

      fetch(form.action, {
        method:  'POST',
        body:    new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (res.ok || res.redirected) {
            emailInput.value = '';
            if (successMsg) successMsg.style.display = 'block';
            if (errorMsg)   errorMsg.style.display   = 'none';
          } else {
            throw new Error('failed');
          }
        })
        .catch(function () {
          if (errorMsg)   errorMsg.style.display   = 'block';
          if (successMsg) successMsg.style.display = 'none';
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled    = false;
            submitBtn.textContent = originalTxt;
            submitBtn.style.opacity = '';
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterForm);
  } else {
    initNewsletterForm();
  }

})();